import { render, staticRenderFns } from "./clickyarseoEdit.vue?vue&type=template&id=bf3cec08"
import script from "./clickyarseoEdit.vue?vue&type=script&lang=js"
export * from "./clickyarseoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports